@if (isPopupVisible) {
  <dx-popup
    contentTemplate="popup-content"
    [(visible)]="isPopupVisible"
    title="Delegation"
    position="center"
    [hideOnOutsideClick]="false"
    [showTitle]="true"
    [height]="400"
    [width]="650"
    [resizeEnabled]="false"
    [dragEnabled]="false"
    (onHiding)="onCloseModal()"
  >
    <div *dxTemplate="let data of 'popup-content'">
      <form #infoForm="ngForm" class="form_grid" body>
        <div class="pepTc">
          <div id="container-autocomplete">
            <dx-autocomplete
              [dataSource]="resourcesOptions"
              [(ngModel)]="projectInfo['projectEngineer']['fullname']"
              label="PE/TC"
              labelMode="floating"
              valueExpr="name"
              (onSelectionChanged)="selectedPe($event)"
              [showClearButton]="true"
              name="pepTc"
              class="input-autocomplete"
            ></dx-autocomplete>
            <dx-button
              (onClick)="addDelegate()"
              text="Delegate"
              type="default"
              [disabled]="
                projectInfo['projectEngineer']['fullname'] ? false : true
              "
            >
            </dx-button>
          </div>
          @if (delegateList().length) {
            <h3>Delegates list</h3>
            @for (delegato of delegateList(); track $index) {
              @if (delegato.resourceFullName) {
                <div class="container-delegate">
                  {{ delegato.resourceFullName }}
                  <span
                    class="material-symbols-outlined"
                    (click)="removeDelegate(delegato)"
                    style="cursor: pointer; display: inline-block"
                    >delete</span
                  >
                </div>
              }
            }
          } @else {
            No delegates
          }
        </div>
      </form>
    </div>
  </dx-popup>

  <dx-load-panel
    [visible]="!!signalService.loadingSignal()"
    [shading]="true"
    shadingColor="'#000000'"
    [showPane]="false"
  >
    <dxo-position at="center"></dxo-position>
  </dx-load-panel>
}
